import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import {
    changeCalendarViewType,
    goToDate,
    goToNextSurfaceDateRange,
    goToPreviousSurfaceDateRange,
    goToToday,
    launchNewEvent,
    openSurfacePrintDialog,
} from 'owa-calendar-module-commanding';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarCommandingOrchestration" */ './lazyIndex')
);

registerLazyOrchestrator(
    changeCalendarViewType,
    lazyModule,
    m => m.changeCalendarViewTypeOrchestrator
);
registerLazyOrchestrator(goToDate, lazyModule, m => m.goToDateOrchestrator);
registerLazyOrchestrator(
    goToNextSurfaceDateRange,
    lazyModule,
    m => m.goToNextSurfaceDateRangeOrchestrator
);
registerLazyOrchestrator(
    goToPreviousSurfaceDateRange,
    lazyModule,
    m => m.goToPreviousSurfaceDateRangeOrchestrator
);
registerLazyOrchestrator(goToToday, lazyModule, m => m.goToTodayOrchestrator);
registerLazyOrchestrator(launchNewEvent, lazyModule, m => m.launchNewEventOrchestrator);
registerLazyOrchestrator(
    openSurfacePrintDialog,
    lazyModule,
    m => m.openSurfacePrintDialogOrchestrator
);

export { lazyModule as lazyCalendarCommandingOrchestrationModule };
